export default "__VITE_ASSET__Y4dF0RJT__"